import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
// import { AgmCoreModule } from "@agm/core";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { StoreModule } from "@ngrx/store";

import { AppComponent } from './app.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';

// import { DragulaService } from "ng2-dragula";
import { AuthService } from './shared/auth/auth.service';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { JwtInterceptor } from './shared/auth/jwt.interceptor';
import { LoginPageComponent } from './pages/content-pages/login/login-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToasterService } from './shared/services/toaster/toaster.service';
import { UsersComponent } from './users/users.component';
import { CompaniesComponent } from './companies/companies.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { PlayersComponent } from './players/players.component';
import { PlayerDetailsComponent } from './players/player-details/player-details.component';
import { LoaderService } from './shared/services/loader/loader.service';
import { LoaderInterceptor } from './shared/services/loader/loader-interceptor.interceptor';
import { MatExpansionModule } from '@angular/material/expansion';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PollyComponent } from './tts/polly/polly.component';
import { AsianPaintsGlobetrotterComponent } from './asian-paints-globetrotter/asian-paints-globetrotter.component';
import { AsianPaintsService } from './asian-paints/asian-paints.service';
import { MatNativeDateModule } from '@angular/material/core';
import { TalentLitmusCoreModule } from './talent-litmus-core/talent-litmus-core.module';
import { DatatableModule } from './shared/datatable/datatable.module';
import { VoicesModule } from './game/lvl1/voices/voices.module';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    ContentLayoutComponent,
    LoginPageComponent,
    UsersComponent,
    CompaniesComponent,
    PlayersComponent,
    PlayerDetailsComponent,
    PollyComponent,
    AsianPaintsGlobetrotterComponent,
  ],
  imports: [
    PdfViewerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    MatNativeDateModule,
    // LaminateModule,
    // StoreModule.forRoot({}),
    AppRoutingModule,
    SharedModule,
    DatatableModule,
    VoicesModule,
    TalentLitmusCoreModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    // AgmCoreModule.forRoot({
    //   apiKey: "YOUR KEY"
    // }),
  ],
  providers: [
    AuthService,
    ToasterService,
    LoaderService,
    AsianPaintsService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
